import { connect } from 'react-redux'
import PcbView from '../components/PcbView'
import {
  runLinacMoveTest,
  pushPCBTestData,
  runMotorTest,
  runLedTest,
  refreshDeviceData
} from '../../../store/deviceHistory'

const mapDispatchToProps = {
  runLinacMoveTest,
  pushTestData: pushPCBTestData,
  runMotorTest,
  runLedTest,
  refreshDeviceData
}

const mapStateToProps = (state, ownProps) => {
  return {
    deviceHistory: state.deviceHistory[ownProps.params.device_string]
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PcbView)



// WEBPACK FOOTER //
// ./src/routes/PCB/containers/PcbContainer.js